<template>
  <div class="samecategory">
    <div class="comp-title mt-5">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Tin liên quan
        </h1>
      </div>
    </div>
    <div style="clear: both"></div>

    <div class="row text-left mt-4">
      <div class="col-md-6 position-relative pl-0 mb-2" v-for="item in listNews">
        <a :href="prefixUrl + item.id + '/' + item.alias">
          <img :src="item.thumbnail" class="img-w-60 float-left mr-2"/>
          <h4 class="song color-text">{{ item.title }}</h4>
          <p class="singer color-blue text-right">Đọc tiếp <span class="fa fa-angle-double-right"></span></p>
        </a>
      </div>

      <!--<div class="col-md-6 position-relative pl-0">
        <a href="#">
          <img src="https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg" class="img-w-60 float-left mr-2"/>
          <h4 class="song color-text">Tuấn hưng cạo trọc đầu vì Việt Nam thua trận...</h4>
          <p class="singer color-blue text-right">Đọc tiếp <span class="fa fa-angle-double-right"></span></p>
        </a>
      </div>

      <div class="col-md-6 position-relative pl-0">
        <a href="#">
          <img src="https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg" class="img-w-60 float-left mr-2"/>
          <h4 class="song color-text">Tuấn hưng cạo trọc đầu vì Việt Nam thua trận...</h4>
          <p class="singer color-blue text-right">Đọc tiếp <span class="fa fa-angle-double-right"></span></p>
        </a>
      </div>

      <div class="col-md-6 position-relative pl-0">
        <a href="#">
          <img src="https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg" class="img-w-60 float-left mr-2"/>
          <h4 class="song color-text">Tuấn hưng cạo trọc đầu vì Việt Nam thua trận...</h4>
          <p class="singer color-blue text-right">Đọc tiếp <span class="fa fa-angle-double-right"></span></p>
        </a>
      </div>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "SameCategory",
    props: {
      listNews: Array
    },
    data () {
      return {
        prefixUrl: this.settings.prefixNews
      }
    },
    created () {
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/entertainmentdetail/wap/SameCategory.vue